import { useDispatch } from "react-redux";
import { backendApi } from "store/api/enhancedApi";
import { useLogoutMutation } from "store/api/generatedApi";
import { getAuth, signOut as signOutFirebase } from "firebase/auth";

export const useSignOut = () => {
  const dispatch = useDispatch();
  const auth = getAuth();
  const [logout] = useLogoutMutation();

  const signOut = async () => {
    await logout()
      .unwrap()
      .catch(() => undefined);
    await signOutFirebase(auth);
    dispatch(backendApi.util.resetApiState());
  };

  return signOut;
};
